import { InitResponse, Currencies, UserPermissionStruct, MessageItem } from "@/models/apiModels";
import { makeObservable, observable, action } from "mobx";

class AuthStore {
    isAuthenticated: boolean = false;
    displayName: string = "";
    organizationLogoUrl: string = "";
    cultureName: string = "he-IL";
    cultureTwoLetter: string = "he";
    appVersion: string = "";
    timeZone: string = "Asia/Jerusalem";
    isRtl: boolean = false;
    phoneNumber: string = "";
    isActive: boolean = false;
    imagePath: string = "";
    currencies: Currencies[] = [];
    messages: MessageItem[] = [];
    currencyDictionary: { [key: string]: string } = {};
    walletBalanceMessageFrequency: number = 0;
    walletLoadingMinDays: number = 0;
    walletLoadingPortionSize?: number | null = null;
    walletMaxLoadingAmount: number = 0;
    permissions: UserPermissionStruct[] = [];
    employeeImportFrequencyValid: boolean = true;
    unreadMessagesCount: number = 0;
    walletSource: number = 0;
    recaptchaSiteKey: string = "";

    constructor() {
        makeObservable(this, {
            isAuthenticated: observable,
            update: action,
            appVersion: observable,
            displayName: observable,
            cultureName: observable,
            organizationLogoUrl: observable,
        });
    }

    public update(response: InitResponse) {
        this.isAuthenticated = response.initResponse.isAuthenticated;
        this.displayName = response.initResponse.displayName;
        this.organizationLogoUrl = response.initResponse.organizationLogoUrl;
        this.cultureName = response.initResponse.cultureName;
        this.cultureTwoLetter = response.initResponse.cultureTwoLetter;
        this.appVersion = response.initResponse.appVersion;
        this.timeZone = response.initResponse.timeZone;
        this.isRtl = response.initResponse.isRtl;
        this.phoneNumber = response.initResponse.phoneNumber;
        this.isActive = response.initResponse.isActive;
        this.imagePath = response.initResponse.imagePath;
        this.currencies = response.initResponse.currencies;
        if (response.initResponse.currencies) {
            this.currencyDictionary = Object.fromEntries(this.currencies.map(({ id, ...rest }) => [id, rest.symbol]));
        }
        this.walletBalanceMessageFrequency = response.initResponse.walletBalanceMessageFrequency;
        this.walletLoadingMinDays = response.initResponse.walletLoadingMinDays;
        this.walletLoadingPortionSize = response.initResponse.walletLoadingPortionSize;
        this.walletMaxLoadingAmount = response.initResponse.walletMaxLoadingAmount;
        this.permissions = response.initResponse.permissions;
        this.messages = response.initResponse.messages;
        this.employeeImportFrequencyValid = response.initResponse.employeeImportFrequencyValid;
        if (response.initResponse.messages) {
            this.unreadMessagesCount = response.initResponse.messages.filter((x) => x.read === false).length;
        }
        this.walletSource = response.initResponse.walletSource;
        this.recaptchaSiteKey = response.initResponse.recaptchaSiteKey;
    }

    public setMessageAsRead(id: number) {
        const found = this.messages.find((x) => x.id === id);
        if (found) {
            found.read = true;
        }
        if (this.unreadMessagesCount > 0) {
            this.unreadMessagesCount = this.unreadMessagesCount - 1;
        }
    }
}

export default new AuthStore();
